<template>
  <Breadcrumb
    :id="selectionType.id"
    :name="selectionType.name"
    :type="$tc('models.selectiontype', 1) | capitalize"
    :showBackButton="showBackButton"
    @backButtonPressed="clickBack"
  >
    <template v-slot:icon>
      <MapIcon v-bind="networkIcon" icon="13_roadsign" :size="39"/>
    </template>
  </Breadcrumb>
</template>

<script>
import { mapGetters } from 'vuex';

import Breadcrumb from '@/components/Layout/Breadcrumb.vue';
import NetworkIcon from '@/enums/NetworkIcon';

import MapIcon from '@/components/Map/MapIcon.vue';

export default {
  name: 'BreadcrumbSelectionType',
  components: { Breadcrumb, MapIcon },
  props: {
    selectionType: {
      type: Object,
      required: true,
    },
    showBackButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      networkIcon: NetworkIcon,
    };
  },
  computed: {
    ...mapGetters({
      network: 'settings/getNetworkModel',
    }),
  },
  methods: {
    clickBack() {
      if (this.showBackButton) {
        this.$emit('backButtonPressed');
      }
    },
  },
};
</script>
